"use strict";

function qw(a) {
  console.log(a);
}

function proof_slider() {
  let elm = document.querySelector(".home-proof__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "carousel",
      gap: 35,
      perView: 3,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        768: {
          perView: 1.8,
        },
        600: {
          perView: 1.5,
          peek: {
            before: 60,
            after: 60,
          },
        },
        430: {
          perView: 1,
          center: true,
          peek: {
            before: 20,
            after: 20,
          },
        },
      },
    });

    slider_ex.mount();
  }
}

function trust_slider() {
  let elm = document.querySelector(".home-trust__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "carousel",
      gap: 35,
      perView: 2,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        768: {
          perView: 2,
        },
        600: {
          perView: 2,
        },
        430: {
          perView: 1,
          center: true,
        },
      },
    });

    slider_ex.mount();
  }
}

function video_slider() {
  let elm = document.querySelector(".home-video__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "slider",
      gap: 20,
      perView: 4.8,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        1200: {
          perView: 3.4,
        },
        992: {
          perView: 3.1,
        },
        768: {
          perView: 2.4,
        },
        600: {
          perView: 2.1,
        },
        430: {
          perView: 1,
          center: true,
        },
      },
    });

    slider_ex.mount();
  }
}

function social_slider() {
  let elm = document.querySelector(".home-social__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "carousel",
      autoplay: 1,
      animationDuration: 4000,
      animationTimingFunc: "linear",
      gap: 20,
      perView: 6,
      breakpoints: {
        1200: { perView: 4 },
        1024: { perView: 3.5 },
        768: { perView: 2.5 },
        600: { perView: 2 },
        430: { perView: 1.5 },
      },
    });

    slider_ex.on("run.after", () => {
      slider_ex.go(">");
    });

    slider_ex.mount();
  }
}

function observeVideo() {
  const videoElements = document.querySelectorAll(".js-observer-video");

  const videoObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.1,
    },
  );

  videoElements.forEach((video) => {
    videoObserver.observe(video);
  });
}

function guidePlayVideo() {
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target.querySelector("video");
        if (video) {
          video.play().catch((error) => {
            console.warn("Autoplay is blocked by your browser. The video must be muted.", error);
          });

          // Если нужно запустить только один раз и больше не отслеживать:
          // observer.unobserve(entry.target);
        }
      }
    });
  }, observerOptions);

  document.querySelectorAll(".home-guide__video").forEach((block) => {
    observer.observe(block);
  });
}

function other_events() {
  document.querySelectorAll(".home-trust__item-plus").forEach((el) => {
    el.addEventListener("click", () => {
      let parent = el.closest(".home-trust__item");
      if (!parent) {
        return;
      }

      parent.classList.toggle("active");
    });
  });

  document.querySelectorAll(".home-video__item-video").forEach((el) => {
    const video = el.querySelector("video");
    const icon = el.querySelector("svg path");

    if (!video || !icon) return;

    video.addEventListener("waiting", () => el.classList.add("loading"));
    video.addEventListener("playing", () => el.classList.remove("loading"));
    video.addEventListener("pause", () => el.classList.remove("loading"));

    el.addEventListener("click", () => {
      if (!video.paused) {
        video.pause();
        el.classList.remove("play");
        video.removeAttribute("autoplay");
        icon.setAttribute("d", "m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393");
      } else {
        video.play();
        el.classList.add("play");
        video.setAttribute("autoplay", "");
        icon.setAttribute("d", "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5");
      }
    });
  });

  document.querySelectorAll(".product__faq-item").forEach((el) => {
    el.addEventListener("click", () => {
      el.classList.toggle("active");
    });
  });

  document.querySelectorAll(".img-faq__item").forEach((el) => {
    el.addEventListener("click", () => {
      el.classList.toggle("active");
    });
  });
}

window.productGallery = null;

function init_product_swiper_main() {
  if ("undefined" === typeof wdSwiper) {
    console.error("Swiper is not defined");
    return;
  }

  let galleryWrapper = document.querySelector(".product-gallery");
  if (!galleryWrapper) {
    return null;
  }

  var gallery = galleryWrapper.querySelector(".product-gallery__wrapper");
  var thumbnails = galleryWrapper.querySelector(".product__image-thumb .product__image-thumb-wrap");
  if (!gallery) {
    return;
  }

  var mainCarouselArg = {
    slidesPerView: 1,
    loop: "",
    centeredSlides: 0,
    autoHeight: 0,
    grabCursor: true,
    a11y: {
      enabled: false,
    },
    breakpoints: {
      1025: {
        slidesPerView: 1,
        initialSlide: 0,
      },
      768.98: {
        slidesPerView: 1,
        initialSlide: 0,
      },
      0: {
        slidesPerView: 1,
        initialSlide: 0,
      },
    },
    slideClass: "product__image-carousel-item",
    slideActiveClass: "is--active",
    slideVisibleClass: "slide--is-visible",
    slideNextClass: "slide--next",
    slidePrevClass: "slide--prev",
    slideFullyVisibleClass: "full--visible",
    slideBlankClass: "slide--blank",
    lazyPreloaderClass: "lazy-preloader",
    containerModifierClass: "",
    wrapperClass: "product__image-carousel-wrap",
    on: {
      slideChange: function () {
        const index = this.activeIndex;
        gallery.dispatchEvent(new CustomEvent("wdSlideChange", { activeIndex: index }));
      },
    },
  };
  if (gallery.parentElement.querySelector(".sw-btn-arrow.sw-next")) {
    mainCarouselArg.navigation = {
      nextEl: gallery.parentElement.querySelector(".sw-btn-arrow.sw-next"),
      prevEl: gallery.parentElement.querySelector(".sw-btn-arrow.sw-prev"),
      disabledClass: "is--disabled",
      lockClass: "is--lock",
      hiddenClass: "is--hide",
    };
  }

  if (thumbnails) {
    let thumbnailsWrapper = galleryWrapper.querySelector(".product__image-thumb");
    let thumbnailsDirection = "vertical";
    if (thumbnails.children.length) {
      if ("vertical" === thumbnailsDirection && !window.getComputedStyle(galleryWrapper).getPropertyValue("--wd-thumbs-height")) {
        galleryWrapper.style.setProperty("--wd-thumbs-height", thumbnailsWrapper.offsetHeight + "px");
      }

      if (window.screen.width <= 992) {
        thumbnailsDirection = "horizontal";
      }
      var thumbnDesktop = 3;
      var thumbnTablet = 3;
      var thumbnMobile = 3;
      mainCarouselArg.thumbs = {
        swiper: {
          el: thumbnails,
          slidesPerView: thumbnDesktop,
          direction: thumbnailsDirection,
          centeredSlides: 0,
          autoHeight: 0,
          id: "carousel-thumbnails",
          slideClass: "product__image-thumb-item",
          slideActiveClass: "is--active",
          slideVisibleClass: "slide--visible",
          slideNextClass: "slide--next",
          slidePrevClass: "slide--prev",
          slideFullyVisibleClass: "full--visible",
          slideBlankClass: "slide--blank",
          lazyPreloaderClass: "lazy-preloader",
          containerModifierClass: "",
          wrapperClass: "product__image-thumb-wrapper",
          grabCursor: true,
          a11y: {
            enabled: false,
          },
          breakpoints: {
            1025: {
              slidesPerView: thumbnDesktop,
              spaceBetween: 10,
            },
            768.98: {
              slidesPerView: thumbnTablet,
              spaceBetween: 10,
            },
            0: {
              slidesPerView: thumbnMobile,
              spaceBetween: 10,
            },
          },
          navigation: {
            nextEl: thumbnails.nextElementSibling.querySelector(".sw-btn-arrow.sw-next"),
            prevEl: thumbnails.nextElementSibling.querySelector(".sw-btn-arrow.sw-prev"),
            disabledClass: "is--disabled",
            lockClass: "is--lock",
            hiddenClass: "is--hide",
          },
          on: {
            resize: function (swiper) {
              if (swiper.currentBreakpoint > 1024 && !swiper.isVertical()) {
                swiper.changeDirection("vertical");
              } else if (swiper.currentBreakpoint <= 1024 && !swiper.isHorizontal()) {
                swiper.changeDirection("horizontal");
              }
            },
          },
        },
        slideThumbActiveClass: "thumb--active",
        thumbsContainerClass: "product__image-thumb-wrap",
      };
    }
  }

  const carousel = new wdSwiper(gallery, mainCarouselArg);
  window.productGallery = carousel;
  return carousel;
}

function productVariations() {
  const container = document.querySelector(".product-custom-purchase-flow");
  if (!container) return;

  const variantInput = document.getElementById("js-variant-input");
  const sellingPlanInput = document.getElementById("js-selling-plan-input");
  const priceDisplay = document.getElementById("js-total-price-display");
  const planSelector = document.querySelector(".js-selling-plan-selector");
  const btnAddToCart = container.querySelector(".js-add-to-cart");
  const btnBuyNow = container.querySelector(".js-buy-now");

  // Переключение карточек (вариантов)
  container.querySelectorAll(".bundle-option-card").forEach((card) => {
    card.addEventListener("click", () => {
      container.querySelectorAll(".bundle-option-card").forEach((c) => c.classList.remove("is-selected"));
      card.classList.add("is-selected");

      const imageId = card.dataset.imageId || 0;

      if (imageId) {
        const thumbSelector = '.product__image-carousel-item[data-image-id="' + imageId + '"]';

        const targetThumb = document.querySelector(thumbSelector);

        if (targetThumb) {
          const allThumbs = Array.from(document.querySelectorAll(".product__image-carousel-item"));
          const thumbIndex = allThumbs.indexOf(targetThumb);

          if (window.productGallery && typeof window.productGallery.slideTo === "function") {
            window.productGallery.slideTo(thumbIndex);
          }
        }
      }

      variantInput.value = card.dataset.variantId;
      updatePriceDisplay();
    });
  });

  // Переключение типа покупки (разовая/подписка)
  container.querySelectorAll('input[name="purchase_type_toggle"]').forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const details = radio.closest(".js-method-row").querySelector(".js-sub-details");
      const rows = container.querySelectorAll(".js-method-row");

      // Подсвечиваем активную строку
      rows.forEach((r) => r.classList.remove("active"));
      e.target.closest(".js-method-row").classList.add("active");

      const method = e.target.closest(".js-method-row").dataset.method;

      container.querySelectorAll(".method-row .js-sub-details").forEach((el) => {
        el.style.display = "none";
      });

      sellingPlanInput.value = "";

      if (details) {
        details.style.display = "block";
      }

      if (method == "subscription") {
        sellingPlanInput.value = planSelector ? planSelector.value : "";
      }
      updatePriceDisplay();
    });
  });

  // Изменение частоты доставки в селекте
  if (planSelector) {
    planSelector.addEventListener("change", () => {
      if (document.querySelector('input[name="purchase_type_toggle"]:checked').value === "subscription") {
        sellingPlanInput.value = planSelector.value;
      }
    });
  }

  function updatePriceDisplay() {
    const activeCard = container.querySelector(".bundle-option-card.is-selected");
    const isSub = document.querySelector('input[name="purchase_type_toggle"]:checked').value === "subscription";
    let price = activeCard.dataset.variantPrice;
    priceDisplay.textContent = price;
  }

  async function addToCart(goToCheckout = false) {
    const variantId = variantInput.value;
    const sellingPlanId = sellingPlanInput.value;

    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    // Если выбрана подписка, добавляем selling_plan
    if (sellingPlanId) {
      formData.items[0].selling_plan = parseInt(sellingPlanId);
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // Если нажата "Buy Now" — идем на чекаут, иначе в корзину
        window.location.href = goToCheckout ? "/checkout" : "/cart";
      } else {
        console.error("Ошибка при добавлении в корзину");
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  }

  // Слушатель для первой кнопки (В корзину)
  btnAddToCart.addEventListener("click", (e) => {
    e.preventDefault();
    addToCart(false);
  });

  // Слушатель для второй кнопки (Чекаут)
  btnBuyNow.addEventListener("click", (e) => {
    e.preventDefault();
    addToCart(true);
  });
}

function product_proof_slider() {
  let elm = document.querySelector(".product-proof__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "carousel",
      gap: 0,
      perView: 3,
      focusAt: "center",
      autoplay: 2500,
      animationDuration: 10,
      rewind: false,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        768: {
          perView: 1.8,
        },
        600: {
          perView: 1.5,
          peek: {
            before: 60,
            after: 60,
          },
        },
        430: {
          perView: 1,
          center: true,
          peek: {
            before: 20,
            after: 20,
          },
        },
      },
    });

    slider_ex.mount();
  }
}

function product_inside_slider() {
  let elm = document.querySelector(".inside-slider__list.glide");

  if (elm) {
    let slider_ex = new Glide(elm, {
      type: "carousel",
      gap: 15,
      perView: 5,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        1280: {
          perView: 4,
        },
        1024: {
          perView: 3.1,
        },
        768: {
          perView: 2.2,
        },
        600: {
          perView: 1.8,
          peek: {
            before: 60,
            after: 60,
          },
        },
        430: {
          perView: 1,
          center: true,
        },
      },
    });

    slider_ex.mount();
  }
}

function product_comprasion_slider() {
  let elm = document.querySelector(".product-comprasion__list.glide");

  if (elm) {
    const countSlides = elm.dataset.items || 2;
    let slider_ex = new Glide(elm, {
      type: "slider",
      gap: 35,
      perView: countSlides,
      bound: true,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        768: {
          perView: 2,
        },
        600: {
          perView: 2,
        },
        430: {
          perView: 1,
          center: true,
        },
      },
    });

    slider_ex.mount();
  }
}

function moveFaq() {
  if (window.screen.width > 1025) {
    return;
  }
  const faqBlock = document.querySelector(".product__faq");
  const purchaseFlow = document.querySelector(".product-custom-purchase-flow");

  if (faqBlock && purchaseFlow) {
    purchaseFlow.after(faqBlock);
    faqBlock.style.display = "flex";
  }
}

function startTheme() {
  proof_slider();
  trust_slider();
  video_slider();
  social_slider();
  guidePlayVideo();
  product_proof_slider();
  product_inside_slider();
  product_comprasion_slider();
  init_product_swiper_main();
  productVariations();
  moveFaq();
  observeVideo();
  other_events();
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  startTheme();
} else {
  document.addEventListener("DOMContentLoaded", startTheme);
}
